//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,

  props: {
    items: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: false,
      default: null,
    },
  },

  computed: {
    filteredItems() {
      let filteredItems = this.items
      if (this.filterIsActive) {
        filteredItems = this.items.filter(this.checkForMatchingTags)
      }
      return filteredItems
    },
    filterIsActive() {
      for (const filter in this.filters) {
        if (this.filters[filter] && this.filters[filter].checked === true) {
          return true
        }
      }
      return false
    },
  },
  methods: {
    checkForMatchingTags(item) {
      const match = item.tags.some(
        (tag) => this.filters[tag.id] && this.filters[tag.id].checked
      )
      return match
    },
  },
}
